import BaseApi from './base.api'

class AccountingApi extends BaseApi {
  budgetTagsUrl = 'budget-tags/'
  budgetDocumentsUrl = 'budget-documents/'
  budgetDocumentRowsUrl = 'budget-document-rows/'
  budgetDocumentRowCategoriesUrl = 'budget-document-row-categories/'
  budgetDocumentExportTemplatesUrl = 'budget-document-export-templates/'
  companyDataUrl = 'company-data/'
  documentTermTemplatesUrl = 'document-term-templates/'
  documentPrintTemplatesUrl = 'document-print-templates/'

  addBudgetTagAsync = (data) => this.postAsync(this.budgetTagsUrl, data)
  archiveBudgetDocumentAsync = (id) => this.putAsync(`${this.budgetDocumentsUrl}${id}/archive/`)
  cloneBudgetDocumentAsync = (id, data) => this.postAsync(`${this.budgetDocumentsUrl}${id}/clone/`, data)
  generateProjectFromBudgetDocumentAsync = (id, data) => this.postAsync(`${this.budgetDocumentsUrl}${id}/generate-project/`, data)
  deleteBudgetDocumentAsync = (id, config) => this.deleteAsync(`${this.budgetDocumentsUrl}${id}/`, config)
  deleteBudgetDocumentRowAsync = (id, config) => this.deleteAsync(`${this.budgetDocumentRowsUrl}${id}/`, config)

  downloadBudgetDocumentRowFileAsync = (id, fileName) => this.downloadAsync(`${this.budgetDocumentRowsUrl}files/${id}`, fileName)

  exportBudgetDocumentToExcelAsync = (id, fileName, data) => this.downloadAsync(`${this.budgetDocumentsUrl}${id}/export-excel/`, fileName, data, { method: 'post' })

  getBudgetDocumentExportTemplatesAsync = (params) => this.getAsync(this.budgetDocumentExportTemplatesUrl, params)
  getBudgetDocumentNextIdAsync = (year) => this.getAsync(`${this.budgetDocumentsUrl}next/`, {year})
  getBudgetDocumentRowCategoriesAsync = (params) => this.getAsync(this.budgetDocumentRowCategoriesUrl, params)
  getBudgetDocumentKpiSummaryAsync = (params) => this.getAsync(`${this.budgetDocumentsUrl}kpi-summary/`, params)
  getBudgetDocumentsAsync = (params) => this.getAsync(this.budgetDocumentsUrl, params)
  getBudgetDocumentRowsAsync = (params) => this.getAsync(this.budgetDocumentRowsUrl, params)
  getBudgetDocumentByIdAsync = (id, params) => this.getAsync(`${this.budgetDocumentsUrl}${id}/`, params)
  getBudgetDocumentSchedulesAsync = (id) => this.getAsync(`${this.budgetDocumentsUrl}${id}/schedules/`)
  getBudgetDocumentPlannedPerUnitAsync = (id, unitOfMeasureCode) => this.getAsync(`${this.budgetDocumentsUrl}${id}/planned-per-unit/`, { unit_of_measure_code: unitOfMeasureCode })
  getBudgetTagsAsync = (params) => this.getAsync(this.budgetTagsUrl, params)
  getCompanyDataAsync = (params) => this.getAsync(this.companyDataUrl, params)

  getBudgetDocumentMagicLinkAsync = async(id, params) => this.getAsync(`${this.budgetDocumentsUrl}${id}/magic-link/`, params)
  printBudgetDocumentMagicLinkAsync = async(id, params) => this.getAsync(`${this.budgetDocumentsUrl}${id}/print-magic-link/`, params)
  printBudgetDocumentAsync = (id, fileName, params) => this.downloadAsync(`${this.budgetDocumentsUrl}${id}/print/`, fileName, null, {params})
  previewBudgetDocumentAsync = (id, params) => this.getBlobUrlAsync(`${this.budgetDocumentsUrl}${id}/print/`, params)
  reorderBudgetDocumentRowsAsync = (id, data) => this.postAsync(`${this.budgetDocumentRowsUrl}${id}/reorder_row_numbers/`, data)
  deleteDocumentTermTemplateAsync = (id) => this.deleteAsync(`${this.documentTermTemplatesUrl}${id}/`)
  getDocumentTermTemplatesAsync = (params) => this.getAsync(this.documentTermTemplatesUrl, params)
  upsertDocumentTermTemplateByTitleAsync = (data) => this.postAsync(`${this.documentTermTemplatesUrl}upsert-by-title/`, data)

  costReportRowsUrl = 'cost-report-rows/'
  costReportRowTagsUrl = 'cost-report-row-tags/'
  expenseClaimsUrl = 'expense-claims/'
  invoicesUrl = 'invoices/'
  invoiceRowsUrl = 'invoice-rows/'

  getInvoicesAsync = (params) => this.getAsync(this.invoicesUrl, params)
  upsertInvoiceAsync = (data) => this.upsertAsync(this.invoicesUrl, data)
  deleteInvoiceAsync = (id) => this.deleteAsync(`${this.invoicesUrl}${id}/`)
  previewInvoiceAsync = (id) => this.getBlobUrlAsync(`${this.invoicesUrl}${id}/print/`)
  reorderInvoiceRowsAsync = (id, data) => this.postAsync(`${this.invoiceRowsUrl}${id}/reorder_row_numbers/`, data)
  bulkDeleteInvoiceRowsAsync = (invoiceId, ids) => this.postAsync(`${this.invoiceRowsUrl}bulk-delete/`, { invoice: invoiceId, ids })

  getCostReportRowsAsync = (params) => this.getAsync(this.costReportRowsUrl, params)
  getExpenseClaimStatusCountsAsync = (params) => this.getAsync(`${this.expenseClaimsUrl}status-counts/`, params)
  getCostReportRowTagsAsync = (params) => this.getAsync(this.costReportRowTagsUrl, params)
  upsertCostReportRowAsync = (data) => this.upsertAsync(this.costReportRowsUrl, data)
  deleteCostReportRowAsync = (id, config) => this.deleteAsync(`${this.costReportRowsUrl}${id}/`, config)
  downloadCostReportRowFileAsync = (id, fileName) => this.downloadAsync(`${this.costReportRowsUrl}files/${id}`, fileName)

  reportsUrl = 'reports/'
  reportColumnTemplatesUrl = 'report-column-templates/'

  recomputeReportAsync = (id, dryRun) => this.postAsync(`${this.reportsUrl}${id}/recompute/`, null, { params: dryRun ? { dry_run: 1 } : {} })

  updateCompanyDataAsync = (data) => this.patchAsync(`${this.companyDataUrl}${data.id}/`, data)
  upsertBudgetDocumentAsync = (data) => this.upsertAsync(this.budgetDocumentsUrl, data)
  upsertBudgetDocumentRowAsync = (data) => this.upsertAsync(this.budgetDocumentRowsUrl, data)
  updateTagBudgetDocumentRowsAsync = (tagId, data) => this.patchAsync(`${this.budgetTagsUrl}${tagId}/update-tag-budget-document-rows/`, data)
}

export const accountingApi = new AccountingApi('accounting/')
